import { createApp } from 'vue'
import { MotionPlugin } from '@vueuse/motion' //retrait temporaire pour AnimXYZ
// import VueAnimXyz from '@animxyz/vue3'
// import '@animxyz/core' // Import css here if you haven't elsewhere
import App from './App.vue'
import router from './router';
import { createPinia } from 'pinia'


import { IonicVue } from '@ionic/vue';

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css';
import '@ionic/vue/css/structure.css';
import '@ionic/vue/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/vue/css/padding.css';
import '@ionic/vue/css/float-elements.css';
import '@ionic/vue/css/text-alignment.css';
import '@ionic/vue/css/text-transformation.css';
import '@ionic/vue/css/flex-utils.css';
import '@ionic/vue/css/display.css';

/* Theme variables */
import './theme/variables.css';
import './styles/global.css'
import './styles/modals.css'

import 'mapbox-gl/dist/mapbox-gl.css';


const pinia = createPinia()

const app = createApp(App)
  .use(MotionPlugin)
  .use(IonicVue)
  .use(router)
  .use(pinia);

router.isReady().then(() => {
  app.mount('#app');
});

